import dayjs from 'dayjs';
import {
  ITicketPostAddViewModel,
  ITicketPostInterface,
  ITicketUpdateWithProductViewModel,
  ITicketViewModel,
} from 'Interfaces/ITicketConfig';
import { calculateTicketPostBilling } from './calculateTicketPostBilling';
import { GenerateGuid } from './GuidChecks';
import { mergeEmailSources } from './mergeEmailSources';

export const ConvertToAddTicketPost = (
  ticketPost: ITicketPostInterface,
  ticket: ITicketViewModel | ITicketUpdateWithProductViewModel,
  user: any
) => {
  console.log('ticketpost: ticketPost', ticketPost);
  // XXX her må vi ta hensyn til ticket fixed houtrly rate maxprice fixed prise
  // 1. Bygg toEmail / ccEmail av ALLE tilgjengelige kilder
  const toEmail = mergeEmailSources(
    ticketPost?.ticketPost?.toEmail,
    (ticketPost as any)?.ticketPost?.toEmailList, // hvis finnes
    ticket?.toEmail,
    (ticket as any)?.toEmailList
  );

  const ccEmail = mergeEmailSources(
    ticketPost?.ticketPost?.ccEmail,
    (ticketPost as any)?.ticketPost?.ccEmailList, // hvis finnes
    ticket?.ccEmail,
    (ticket as any)?.ccEmailList
  );

  
   
   // 2. Resten av objektet 
  let _ticketPost: ITicketPostAddViewModel = {
    ticketId: GenerateGuid(),
    status: ticketPost.ticketPost.status,
    startTime: dayjs(ticketPost.ticketPost.startTime), // Send local time, no UTC conversion
    endTime: dayjs(ticketPost.ticketPost.endTime), // Send local time, no UTC conversion
    startDeduction: null, // Send local time
    endDeduction: null, // Send local time
    isBillable: ticketPost.ticketPost.isBillable,
    isOvertime: ticketPost.ticketPost.isOvertime, // Send Overtime, no UTC conversion conversionoverTime,
    isBilled: false,
    internal: ticketPost.ticketPost.internal,
    isInHouse: ticketPost.ticketPost.isInHouse,
    isEmailSent: ticketPost.ticketPost.isEmailSent,
    isCCSent: ticketPost.ticketPost.isCCSent,
    direction: 1,
    authorId: user.id,
    ccEmail: ccEmail || '', 
    toEmail: toEmail || '', 
    receiverId: ticketPost?.ticketPost?.receiverId ?? 'new',
    changedById: user.id,
    message: ticketPost.ticketPost.message || '',
    originalMessage: ticketPost.ticketPost.originalMessage || '',
    attachments: null,
    workRoleId: ticketPost.ticketPost.workRole?.id
      ? ticketPost.ticketPost.workRole?.id
      : null,
    ticketPostBilling: calculateTicketPostBilling(ticketPost, ticket),
    isApp: false,
  };
  return _ticketPost;
};
